import { lazy } from 'react';

// Types
import { GuernseyMessageProps as LazyComponentProps } from './GuernseyMessage.types';

// Config
import guernseyMessageState from './GuernseyMessage.state';

// Components
import withSuspense, { lazyRetry } from '../suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "guernseyMessage" */ './GuernseyMessage')),
);

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'GuernseyMessage');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as GuernseyMessage, guernseyMessageState };
